import { DeviceType } from "src/globalTypes/device";
import * as urlParsers from "./urlParsers";
import wrappedAxios from "../axiosWrapper";
import { AvailableLoginProvidersDTO, LoginDTO, LoginRequest } from "./types";

export const loginWithCookie = () =>
  wrappedAxios<LoginDTO>({
    url: urlParsers.loginWithCookie(),
    method: "get",
  });

export const logout = () =>
  wrappedAxios<void>({
    url: urlParsers.logout(),
    method: "get",
  });

export const login = (data: LoginRequest) =>
  wrappedAxios<LoginDTO>({
    url: urlParsers.login(),
    method: "get",
    headers: {
      password: data.password,
      username: data.login,
    },
  });

export const googleLogin = (token: string, deviceType: DeviceType) =>
  wrappedAxios<LoginDTO>({
    url: urlParsers.googleLogin(token, deviceType),
    method: "get",
  });

export const activeDirectoryLogin = (data: LoginRequest) =>
  wrappedAxios<LoginDTO>({
    url: urlParsers.activeDirectoryLogin(),
    method: "get",
    headers: {
      password: data.password,
      username: data.login,
    },
  });

export const resetLoginCookieKey = (key: string) =>
  wrappedAxios<LoginDTO>({
    url: urlParsers.resetLoginCookieKey(key),
    method: "get",
  });

export const getGoogleLoginClientId = () =>
  wrappedAxios<string>({
    url: urlParsers.googleLoginClientId(),
    method: "get",
  });

export const getAvailableLoginProviders = () =>
  wrappedAxios<AvailableLoginProvidersDTO>({
    url: urlParsers.getAvailableLoginProviders(),
    method: "get",
  });

export const isUserAdmin = () =>
  wrappedAxios<boolean>({
    url: urlParsers.isUserAdmin(),
    method: "get",
  });

export const microsoftLogin = (
  pkceCodeVerifier: string,
  code: string,
  deviceType: DeviceType
) => {
  const params = new URLSearchParams();

  params.append("Code", code);
  params.append("DeviceType", deviceType.toString());
  params.append("PkceCodeVerifier", pkceCodeVerifier);

  const isMobile = deviceType === DeviceType.Mobile;

  params.append("IsMobile", isMobile.toString());

  return wrappedAxios<LoginDTO>({
    url: urlParsers.microsoftLogin(),
    method: "post",
    params,
  });
};
